var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruitments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.72898 11.7876H9.65234V13.6212H8.72898V11.7876Z",
    fill: "#FFCC66"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65234 11.8607V12.2937C9.50367 12.338 9.34977 12.3641 9.19066 12.3641C9.03155 12.3641 8.87766 12.338 8.72898 12.2937V11.8607H9.65234Z",
    fill: "#CEC5AE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20553 10.2569C7.20553 11.4035 8.13512 12.3338 9.28245 12.3338C10.4298 12.3338 11.3594 11.4035 11.3594 10.2569C11.3594 9.11032 10.4298 8.17998 9.28245 8.17998C8.13512 8.17998 7.20553 9.11032 7.20553 10.2569Z",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00205 16.0366V12.6144L8.47318 12.5597L9.20874 13.2665L9.78258 12.5597L11.3789 12.6144V16.0366H7.00205Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91602 13.6396C5.98906 13.0788 6.43248 12.6301 6.99328 12.5675C6.99328 12.5675 6.9985 12.5675 7.0011 12.5675L8.29486 12.5571L9.20779 15.7236L9.97987 12.5571L11.378 12.5675C11.378 12.5675 11.3832 12.5675 11.3858 12.5675C11.9466 12.6301 12.39 13.0788 12.463 13.6396L12.7734 16.0367H11.4693L11.378 15.4185V16.0367H7.0011V15.4185L6.90981 16.0367H5.60562L5.91602 13.6396Z",
    fill: "#FFE4C6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.918 10.6581C16.918 14.8889 13.488 18.3163 9.25978 18.3163C5.03161 18.3163 1.60159 14.8863 1.60159 10.6581C1.60159 6.42997 5.03161 2.99996 9.25978 2.99996C13.488 2.99996 16.918 6.42997 16.918 10.6581ZM14.4609 10.6581C14.4609 7.78632 12.1316 5.45705 9.25978 5.45705C6.38796 5.45705 4.05868 7.78632 4.05868 10.6581C4.05868 13.53 6.38796 15.8592 9.25978 15.8592C12.1316 15.8592 14.4609 13.53 14.4609 10.6581Z",
    fill: "#F48000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0209 20.8414L13.3252 15.3247L14.9841 13.311L21.6824 18.8277C22.2328 19.2816 22.311 20.0954 21.8572 20.6457L21.8415 20.6666C21.3877 21.217 20.5739 21.2952 20.0235 20.8414H20.0209Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitments);
export default __webpack_public_path__ + "static/media/Recruitments.cf35d7ab6244d3a2b06629d34fbb08a0.svg";
export { ForwardRef as ReactComponent };